import { useQuery } from '@tanstack/react-query';
import { cacheAdminApi } from '../api/cacheAdminApi';

/**
 * GET /api/eraf/cache-admin/overview — 전체 개요 (CACHE_READ)
 * queryKey: ['cache-admin', 'overview']
 */
export function useCacheOverview() {
  return useQuery({
    queryKey: ['cache-admin', 'overview'],
    queryFn: () => cacheAdminApi.getOverview(),
    staleTime: 30_000,
  });
}
